import React from "react";
import SovosAboutThisDialog from "mosaic-react/sovos-about-this-dialog";
import { useSovosPlatformContext } from "mosaic-react-platform";

export const AboutThisDialog = (props) => {
    const {
        isOpen,
        setIsAboutThisDialogOpen,
        productName,
        version,
        learnMoreUrl,
        privacyPolicyUrl,
        termsAndConditionsUrl,
    } = props || {};

    const handleAboutThisDialogClose = () => {
        setIsAboutThisDialogOpen(false);
    };

    const { activeProduct, locale } = useSovosPlatformContext() || {};
    const activeProductDescription =
        locale && activeProduct?.locales?.[locale]?.description
            ? activeProduct.locales[locale].description
            : activeProduct?.description;

    return (
        <SovosAboutThisDialog
            description={<div>{activeProductDescription || ""}</div>}
            learnMoreUrl={activeProduct?.marketingUrl || learnMoreUrl}
            onClose={handleAboutThisDialogClose}
            open={isOpen}
            privacyPolicyUrl={activeProduct?.privacyPolicyUrl || privacyPolicyUrl}
            productIconUrl={activeProduct?.iconAboutUrl}
            productName={activeProduct?.name || productName}
            termsAndConditionsUrl={activeProduct?.termsAndConditionsUrl || termsAndConditionsUrl}
            versionNumber={version}
        />
    );
};
